
    import '/opt/buildhome/repo/components/sender/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["sender-demo-basic","sender-demo-submittype","sender-demo-speech","sender-demo-speech-custom","sender-demo-actions","sender-demo-header","sender-demo-header-fixed","sender-demo-send-style","sender-demo-paste-image","sender-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/components/sender/index.en-US.md?type=demo')
};